<template>
  <div class="progress-info">
    <ucar-title type="confirmBack">{{title}}</ucar-title>
    <div class="progress-info-header">
      <p class="progress-info-title">
        <strong v-if="recruitStatus !== 6">预备司机</strong>
        <strong v-else>正式司机</strong>
        {{mobile}}
      </p>
      <p class="progress-info-title" v-if="vuexDriverType === '2' && companyName"><img src="../../assets/icon-company.png">{{companyName}}合作招募</p>
      <p class="progress-info-des" v-if="headerInfo.line1">{{headerInfo.line1}}</p>
      <p class="progress-info-des" v-if="headerInfo.line2">{{headerInfo.line2}}</p>
      <p class="progress-info-error" v-if="headerInfo.errorInfo">{{headerInfo.errorInfo}}</p>
      <ucar-button size="full" v-if="headerInfo.btnText" @click="fillInfo">{{headerInfo.btnText}}</ucar-button>
    </div>
    <div class="progress-info-body">
      <div class="progress-info-fail" v-if="fail.is">
        <div class="progress-info-fail-header">
          <span class="progress-info-fail-label">{{fail.failLabel}}</span>
          <span class="progress-info-fail-date">{{fail.failDate}}</span>
        </div>
        <p>{{fail.failReason}}</p>
        <div class="progress-info-fail-footer">
          <ucar-button size="full" @click="reTry">重新申请</ucar-button>
        </div>
      </div>
      <div class="progress-step-wrapper" v-if="!fail.is">
        <progress-step v-bind="driverStatusBlock" :index="1" v-if="headerInfo.displayStatus >= 1" @btnClick="stepClick">
        </progress-step>
        <progress-step id="trainEl" v-bind="trainStatusBlock" :index="2" v-if="headerInfo.displayStatus === 2" @click="training" @btnClick="training" :stress="true">
        </progress-step>
        <progress-step v-bind="recruitStatusBlock" :index="3" v-if="headerInfo.displayStatus === 2" :mobile="mobile" @btnClick="stepClick">
        </progress-step>
      </div>
      <div class="progress-info-tip" v-if="!fail.is && (vehicleStatusInfo.showVehicleModule || vuexCurrentCity.rentCar || vuexCurrentCity.buyCar || vuexCurrentCity.selfOperated)">
        <div class="progress-tip-header">
          支持加入方式
        </div>
        <div class="progress-tip-body">
          <progress-tip-item
            v-if="vehicleStatusInfo.showVehicleModule"
            title="带车加入"
            type="vehicle"
            @click="go"
            :disabled="vehicleStatusInfo.disabled"
            desc="品牌可信赖，收入有保障"
            :status="vehicleStatusInfo.status"
            :link="vehicleStatusInfo.link"
            :link-text="vehicleStatusInfo.linkText"
            :car-license="vehicleStatusInfo.vehicleLicensePlateNo"
            :statusText="vehicleStatusInfo.statusText">
          </progress-tip-item>
          <progress-tip-item
            title="租车加入"
            v-if="vuexCurrentCity.rentCar"
            @click="go"
            :disabled="!ableShowRentCar"
            link="/showcase/rent"
            :link-text="ableShowRentCar ? '可租车辆': ''"
            desc="内部价格租车，无车也能开专车">
          </progress-tip-item>
          <progress-tip-item
            title="买车加入"
            @click="go"
            :disabled="!ableShowSaleCar"
            v-if="vuexCurrentCity.buyCar"
            link="/showcase/sale"
            :link-text="ableShowSaleCar ? '可买车辆': ''"
            desc="买车加入，赚钱同时赚辆车">
          </progress-tip-item>
          <progress-tip-item
            title="无车全职加入"
            v-if="vuexCurrentCity.selfOperated"
            desc="神州为您分配车辆，享受员工福利">
          </progress-tip-item>
        </div>
      </div>
    </div>

  </div>  
</template>

<script>
import Driver from 'driver.js'
import ProgressStep from '../../components/progress-step'
import ProgressTipItem from '../../components/progress-tip-item'
import { getRecruitProgress } from '../../api'
import { mainStatusEnum, trainStatusEnum, driverStatusEnum, vehicleStatusEnum, checkStatusEnum, driverStatuSteps } from '../../utils/progress-status'
import { hideKey, decodeCompanyId } from '../../utils/transform'
import { alreadyRegText } from '../../utils/constants'
export default {
  components: {
    ProgressStep,
    ProgressTipItem
  },
  data () {
    return {
      trainStress: null,
      recruitStatus: 0, // 招募申请单状态
      trainingStatus: 0, // 培训状态
      driverCheckStatus: 0, // 司机审核状态
      vehicleCheckStatus: 0, // 车辆审核状态
      mobile: '', // 司机手机号
      vehicleLicensePlateNo: '', // 司机车牌号
      failReason: '', // 拒绝/取消原因
      failDate: '', // 拒绝/取消时间
      vehicleBindable: 0, // 是否可绑车辆 也同时表示 此申请单是否进入过人工审核状态 1进入过 2未进入过
      needTrainRemind: false,
      companyName: '',
      driverStatusBlock: {
        title: '提交审核资料',
        statusText: '个人资料审核中',
        fail: false,
        showFailHeader: false,
        active: false,
        failDate: '',
        tip: '',
        failInfo: '',
        btnText: ''
      },
      trainStatusBlock: {
        title: '请完成岗前培训',
        statusText: '当前暂无学习课程',
        btnText: '',
        tip: '',
        active: false,
        disabled: false
      },
      recruitStatusBlock: {
        title: '认证成功',
        statusText: '领取司机身份',
        showIdentity: false,
        disabled: true,
        mobile: '',
        btnText: '',
        fail: false,
        failInfo: ''
      },
      trainInfo: {
        sumCount: 0,
        learnCount: 0
      }
    }
  },
  computed: {
    ableShowRentCar () {
      return this.vuexRentData.vehiclePrice.filter(item => item.cityId === this.vuexCurrentCity.id).length > 0
    },
    ableShowSaleCar () {
      return this.vuexSaleData.vehiclePrice.filter(item => item.cityId === this.vuexCurrentCity.id).length > 0
    },
    fail () {
      const body = {
        is: false,
        failDate: this.failDate,
        failReason: this.failReason,
        failLabel: '',
      }
      const mainStatusText = mainStatusEnum[this.recruitStatus]
      if (mainStatusText === '已拒绝' || mainStatusText === '已取消') {
        body.is = true
        body.failLabel = mainStatusText === '已拒绝' ? '拒绝原因' : '取消原因'
      }
      return body
    },
    headerInfo () {
      const body = {
        line1: '',
        line2: '',
        errorInfo: '',
        btnText: '',
        displayStatus: 0, // 0 不展示任何模块， 1 只展示司机审核进度模块 2 展示所有模块
      }
      const mainStatusText = mainStatusEnum[this.recruitStatus]
      const driverStatusText = driverStatusEnum[this.driverCheckStatus]
      if (mainStatusText === '已注册' || mainStatusText === '报名中') {
        if (driverStatusText === '待提交' || driverStatusText === '审核中' || driverStatusText === '待补充资料') {
              body.line1 = '欢迎你的加入'
              body.line2 = '完善信息即可成为神州司机'
              body.btnText = '继续上传资料'
            }
        if (driverStatusText === '系统审核驳回') {
          body.line1 = '未成功提交'
          body.line2 = '请修改信息重新提报'
          body.errorInfo = '图片识别验证未通过，若识别结果与真实内容不符，请尝试重新上传图片'
          body.btnText = '重新提交资料'
        }
      }
      if ((driverStatusText === '待人工审核' || driverStatusText === '人工审核驳回') ||
        (mainStatusText === '人工审核中' && driverStatusText === '待人工审核') ||
        ((mainStatusText === '审核通过' || mainStatusText === '待入驻' || mainStatusText === '已入驻') && driverStatusText === '审核通过')) {
          body.line1 = '审核通过并完成岗前培训'
          body.line2 = '即可成为正式司机'
          body.displayStatus = 2
      }
      if (driverStatusText === '审核通过' && (this.vehicleBindable === 1 && (mainStatusText === '报名中' ||
        mainStatusText === '人工审核中' || mainStatusText === '审核通过' || mainStatusText === '待入驻' || mainStatusText === '已入驻'))) {
          body.line1 = '只差一步即可成为正式司机'
          body.line2 = '请尽快完成培训'
          body.displayStatus = 2
      }
      if (mainStatusText === '已入驻') {
        body.line1 = '恭喜您！'
        body.line2 = '已成功成为神州正式司机'
      }
      if (mainStatusText === '待入驻') {
        body.line1 = '账号开通失败'
        body.line2 = ''
      }
      if (mainStatusText === '已拒绝') {
        body.line1 = '非常遗憾'
        body.line2 = '您的审核已被系统拒绝'
      }
      if (mainStatusText === '已取消') {
        body.line1 = '对不起'
        body.line2 = '您的申请单已取消'
      }
      return body
    },
    vehicleStatusInfo () {
      const body = {
        showVehicleModule: false,
        vehicleLicensePlateNo: '',
        status: '',
        statusText: '',
        link: '/vehicle-info',
        linkText: '',
        disabled: true,
      }
      const mainStatusText = mainStatusEnum[this.recruitStatus]
      const vehicleStatusText = vehicleStatusEnum[this.vehicleCheckStatus]
      if (mainStatusText !== '已取消' && mainStatusText !== '已拒绝' && this.vuexCurrentCity.hasCar === 1) {
        body.showVehicleModule = true
      }
      if (this.vehicleBindable === 1) {
        body.vehicleLicensePlateNo = this.vehicleLicensePlateNo
      }
      if (this.vehicleBindable === 1 && this.vuexCurrentCity.hasCar === 1 && vehicleStatusText === '已新建') {
        body.linkText = '绑定车辆'
        body.link = `${body.link}?showTips=1`
        body.disabled = false
      }
      if (vehicleStatusText === '审核退回') {
        body.status = 'fail'
        body.statusText = '审核驳回 修改资料'
        body.disabled = false
      }
      if (vehicleStatusText === '待审核' || vehicleStatusText === '待系统审核') {
        body.statusText = '审核中'
        body.disabled = true
      }
      if (vehicleStatusText === '审核未通过' || vehicleStatusText === '已删除') {
        body.status = 'fail'        
        body.statusText = '审核拒绝 更换车辆'
        body.disabled = false
        body.link = '/bind-fail'
      }
      if (vehicleStatusText === '审核通过' || vehicleStatusText === '审核通过未添加车辆') {
        body.status = 'success'        
        body.statusText = '绑定成功'
      }
      return body
    }
  },
  methods: {
    reTry () {
      this.logout()
      this.$router.push(this.vuexIndexUrl)
    },
    go (link) {
      if (/vehicle-info/.test(link)) {
        this.changeStatusToFillInfo()
      }
      this.$router.push(link)
    },
    stressTrain () {
      setTimeout(() => {
        this.trainStress = new Driver({
          stageBackground: 'rgba(0,0,0,0)',
          padding: 0,
          allowClose: false,
          popover: {
            className: 'train-stress-tip',
            title: '不要忘记岗前培训呦',
            showButtons: false,
            position: 'top'
          }
        })
        this.trainStress.highlight('#trainEl')
        const activeElement = this.trainStress.getHighlightedElement()
        const stage = activeElement.stage.node
        const closeEl = document.createElement('div')
        closeEl.innerText = '我知道了'
        closeEl.setAttribute('id', 'custom-close')
        const close = () => {
          this.trainStress.reset()
          closeEl.removeEventListener('click', close)
          closeEl.remove()
        }
        closeEl.addEventListener('click', close)
        stage.appendChild(closeEl)
      }, 500)
    },
    training () {
      this.changeStatusToReviewInfo()
      this.$router.push('/lesson-list')
    },
    fillInfo () {
      this.changeStatusToFillInfo()
      this.$router.push('/driver-info?redirectTo=progress-info')
    },
    stepClick (index) {
      // 点击司机审核模块的按钮则进入司机个人信息填写页
      if (index === 1) {
        this.fillInfo()
        return
      }
      // 点击领取司机身份模块的按钮则唤起APP渠道分发页
      if (index === 3) {
        window.open('https://m.10101111.com/ptdapp/d')
      }
    },
    async getData () {
      // courseRemind参数代表会消耗课程强调次数
      const res = await getRecruitProgress({recruitId: this.vuexRecruitId, courseRemind: 1})
      const { 
        recruitStatus, 
        trainingStatus, 
        driverCheckStatus, 
        vehicleCheckStatus, 
        systemReviewResult, 
        artificialReviewResult,
        creditReviewResult, 
        systemReviewTime, 
        artificialReviewTime,
        creditReviewTime,
        companyId,
        companyName, 
        vehicleBindable, 
        driverRejectedCount, 
        vehicleRejectedCount,
        recruitChannel,
        cancelTime,
        sourceId } = res.recruitApply
      // 由于查询招募进度接口返回的服务城市id不是字符串类型（说实话我也不知道为啥），与原有的服务城市列表中的服务城市id类型不同，所以这里需要转换一下
      const serviceCityId = `${res.recruitApply.serviceCityId}`
      const { driverInfo, vehicleInfo } = res
      this.setVuexDriverType(`${recruitChannel}`)
      if (driverInfo) this.setVuexDriverInfo({...driverInfo, sourceId, serviceCityId, driverRejectedCount, vehicleBindable})
      // 当申请单为企业司机申请单时，需要根据企业ID重新获取服务城市列表
      if (companyId) {
        // 设置当前企业ID时需要重新decodeURI
        this.setVuexCompanyId(decodeCompanyId(companyId))
        await this.setVuexServiceCities({ companyId: this.vuexCompanyId })
      }
      if (serviceCityId) {
        // 由于默认当申请单类型为企业司机报名时需开放带车加入入口，所以优先从当前服务城市列表中找到相应的城市，并将其合并至当前服务城市的对象中
        const currentCity = this.vuexServiceCities.find(item => item.cityId === serviceCityId)
        await this.setVuexCurrentCity({...currentCity, id: serviceCityId})
      }
      if (vehicleInfo) this.setVuexVehicleInfo({...vehicleInfo, vehicleRejectedCount, failReason: res.vehicleArtificialReason ? res.vehicleArtificialReason.join(';') : ''})
      this.vehicleBindable = vehicleBindable
      this.recruitStatus = recruitStatus
      this.trainingStatus = trainingStatus
      this.driverCheckStatus = driverCheckStatus
      this.vehicleCheckStatus = vehicleCheckStatus
      const driverStatusText = driverStatusEnum[this.driverCheckStatus]
      const mainStatusText = mainStatusEnum[this.recruitStatus]
      const trainStatusText = trainStatusEnum[this.trainingStatus]
      const systemStatusText = checkStatusEnum[systemReviewResult]
      const artificialStatusText = checkStatusEnum[artificialReviewResult]
      const creditStatusText = checkStatusEnum[creditReviewResult]
      if (companyName) this.companyName = companyName
      // 解析司机审核进度模块
      if (driverStatuSteps[driverStatusText]) {
        const driverBlockInfo = {
          ...this.driverStatusBlock, ...driverStatuSteps[driverStatusText], failDate: artificialReviewTime
        }
        if (res.driverArtificialReason && res.driverArtificialReason.length > 0) {
          driverBlockInfo.failInfo = res.driverArtificialReason.join(';')
        }
        this.driverStatusBlock = driverBlockInfo
      }
      // 解析司机培训进度模块
      if (res.recruitPushCourse) {
        const { sumCount, learnCount, remind } = res.recruitPushCourse
        this.trainStatusBlock.statusText = sumCount === 0 || !sumCount ? '当前暂无学习课程' :`课程 ${learnCount}/${sumCount}`
        this.trainStatusBlock.disabled = sumCount === 0 || !sumCount
        this.trainStatusBlock.btnText = sumCount && sumCount > learnCount ? '完成在线课程' : ''
        this.needTrainRemind = remind
      } else {
        this.trainStatusBlock.disabled = true
      }
      // 解析车辆信息模块
      if (res.vehicleInfo) {
        const { vehicleLicensePlateNo } = res.vehicleInfo
        this.vehicleLicensePlateNo = vehicleLicensePlateNo
      }
      if (systemStatusText === '拒绝' || creditStatusText === '拒绝' || artificialStatusText === '拒绝') {
        this.failReason = artificialStatusText !== '拒绝' ? '信用综合情况评估未通过' : res.driverArtificialReason.join(';')
        this.failDate = artificialStatusText !== '拒绝' ? systemReviewTime || creditReviewTime : artificialReviewTime
      }
      if (mainStatusText === '已取消') {
        this.failReason = '报名申请已被系统取消'
        this.failDate = cancelTime
      }
      if (trainStatusText === '已完成') {
        this.trainStatusBlock.active = true
        if (this.trainStatusBlock.statusText !== '当前暂无学习课程') this.trainStatusBlock.tip = '课程回顾>'
        this.recruitStatusBlock.mobile = this.vuexPersonMobile
        if (mainStatusText === '待入驻' || mainStatusText === '已入驻') {
          this.recruitStatusBlock.btnText = '下载神州优驾APP 开始工作'
        }
        if (mainStatusText === '待入驻') {
          this.recruitStatusBlock.disabled = true
          this.recruitStatusBlock.failInfo = alreadyRegText
          this.recruitStatusBlock.fail = true
        }
        if (mainStatusText === '已入驻') {
          this.recruitStatusBlock.active = true 
          this.recruitStatusBlock.showIdentity = true
          this.recruitStatusBlock.disabled = false
        }
      }
      // 强调培训
      if (this.headerInfo.displayStatus === 2 && this.needTrainRemind === 1) {
        this.stressTrain()
      }
    }
  },
  beforeDestroy () {
    if (this.trainStress && this.trainStress.reset) {
      this.trainStress.reset()
    }
  },
  mounted () {
    if (this.$route.query.id) this.setVuexRecruitId(this.$route.query.id)
    this.changeStatusToReviewInfo()
    this.mobile = hideKey(this.vuexPersonMobile)
    this.getData()
  }
}
</script>

<style lang="stylus" scoped>
@import '../../styles/variable.styl'

.progress-info {
  .progress-info-header {
    padding: 60px 60px 30px;
    background-color: $ucar_dark_bg;

    p {
      line-height: 1;

      strong {
        margin-right: 40px;
      }
    }

    p:last-child {
      margin-bottom: 10px;
    }

    .progress-info-title {
      display: flex;
      align-items: center;
      font-size: $ucar_font_normal;
      color: $ucar_title_color;
      strong {
        font-weight: normal;
      }
      img {
        height: 32px;
        width: 32px;
        margin-right: 10px;
      }
    }

    .progress-info-des {
      margin-top: 24px;
      font-size: $ucar_font_h4;
      color: $ucar_assist_color;
    }

    .progress-info-error {
      line-height: 1.5;
      font-size: $ucar_font_h5;
      color: $ucar_label_color;
    }

    .progress-info-des, .progress-info-title + .progress-info-title {
      margin-top: 24px;  
    }

    .progress-info-title + .progress-info-des {
      margin-top: 30px;
    }

    .progress-info-des + .progress-info-error {
      margin-top: 20px;
    }

    .button {
      margin-top: 30px;
    }
  }

  .progress-info-body {
    padding: 30px;
    flex: 1 0 auto;
    display: flex;
    flex-flow: column nowrap;
  }
}

.progress-info-tip {

  .progress-tip-header {
    height: 90px;
    line-height: 90px;
    font-size: $ucar_font_normal;
    color: $ucar_font_color;
  }

  .progress-tip-body {
    border: 1PX solid $ucar_light_border;
    border-radius: 8px;
  }
}

.progress-info-fail {
  background-color: #fff;
  flex: 1 0 auto;
  display: flex;
  flex-flow: column nowrap;
  padding: 30px;

  .progress-info-fail-header {
    display: flex;
    align-items: center;
    justify-content: space-between

    .progress-info-fail-label, .progress-info-fail-date {
      font-size: $ucar_font_normal;
      line-height: 1;
    }
    .progress-info-fail-date {
      color: $ucar_font_assist_color;
    }
  }

  p {
    margin-top: 30px;
    flex: 1 0 auto;
    font-size: $ucar_font_normal;
    line-height: 1.5;
  }

  .progress-info-fail-footer {
    margin-top: 30px;
  }
}
</style>